<template>
    <div>
        <div v-for="(item,index) in menuList" :key="index">
            <Dropdown transfer placement="right-start" :key="item.id" @on-click="changeMenu">
                <div class="hover-icon" v-if="item.childList">
                    <i :class="item.menuLogo" :style="[{'fontSize':'14px'}]"></i>
                </div>
                <DropdownMenu slot="list" v-if="item.childList">
                    <template v-for="(child,i) in item.childList">
                        <DropdownItem v-if="!!!child.hasChildList" :name="child.href" :key="child.id"><span style="padding-left:10px;">{{ $t(child.name) }}</span></DropdownItem>
                        <Dropdown transfer placement="right-start" v-if="!!child.hasChildList">
                            <DropdownItem style="width: 200px;">
                                <span style="padding-left:10px;">{{ $t(child.name) }}<Icon style="position: absolute; right: 15px; top: 10px;" type="ios-arrow-forward"></Icon></span>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <template v-for="(third) in child.childList">
                                    <DropdownItem :name="third.href" :key="third.id">
                                        <span style="padding-left:10px;">{{ $t(third.name) }}</span>
                                    </DropdownItem>
                                </template>
                            </DropdownMenu>
                        </Dropdown>
                    </template>
                </DropdownMenu>
                <Tooltip transfer :content="$t(item.name)" v-else placement="right">
                    <div class="hover-icon">
                        <Icon :size="20" :class="item.menuLogo" :type="item.menuLogo" @click="changeMenuTool(item.href)"></Icon>
                    </div>
                </Tooltip>
            </Dropdown> 
        </div>
    </div>
</template>
<script>
import btnComponent from '../btnComponent/btnComponent.vue'
export default {
    name: 'menuShrink',
    props: ['menuList'],
    data () {
        return {
            btnCtrl:''
        }
    },
    computed:{
        openTagMenu(){
            return this.$store.getters.openTagMenu;
        }
    },
    methods: {
        changeMenu (active) {
            this.$router.push({
                path: active
            });
        },
        changeMenuTool(href){
            this.$router.push({
                path: href
            });
        },
        //tag页签
        addItem(){
            let path = this.$route.fullPath;
            let name = this.$route.meta.name;
            let type = this.$route.meta.type;
            let tagMenuPathArr = this.openTagMenu.tagMenuPathArr;
            let tagMenuArr = this.openTagMenu.tagMenuArr;
            if(tagMenuPathArr.indexOf(path) == -1&&type=="菜单"){
                tagMenuArr.push({path:path,name:name});
                tagMenuPathArr.push(path);
                this.$store.commit('openTagMenu',{tagMenuArr:tagMenuArr,tagMenuPathArr:tagMenuPathArr});
            }
        },
    },
    mounted() {
        this.btnCtrl = this.$route.path;
    },
    components:{
        btnComponent
    },
    watch:{
        $route(to, from) {  
            this.btnCtrl = to.fullPath;
            this.addItem();
        }
    }
}
</script>
<style lang="scss" scoped>
.hover-icon{
    width:50px;
    padding:10px 0;
    text-align: center;
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/menuhide/menuHide.vue